import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function NewPasswordForm({ onSubmit, askCurrent = false, submitLabel = "SAVE PASSWORD" }) {
  const [current, setCurrent] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try { await onSubmit(pw, current); } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="new-password-form">
      {askCurrent && (
        <div>
          <Label>Current password</Label>
          <Input type="password" required value={current} onChange={e => setCurrent(e.target.value)} className="rounded-sm" data-testid="current-password"/>
        </div>
      )}
      <div>
        <Label>New password</Label>
        <Input type="password" required value={pw} onChange={e => setPw(e.target.value)} className="rounded-sm" data-testid="new-password"/>
      </div>
      <div>
        <Label>Confirm new password</Label>
        <Input type="password" required value={confirm} onChange={e => setConfirm(e.target.value)} className="rounded-sm" data-testid="confirm-password"/>
      </div>
      <Button type="submit" disabled={loading} className="w-full bg-[#0A1128] hover:bg-slate-800 rounded-sm font-heading h-11" data-testid="new-password-submit">
        {loading ? "Saving..." : submitLabel}
      </Button>
    </form>
  );
}
